import React from "react";
import { HeroProps } from "./Hero.types";
import { Default } from "./variations/Default";

export const Hero: React.FC<HeroProps> = (props) => {
  switch (props.variation) {
    default:
      return <Default {...props} />;
  }
};
